
// używane w widoku pojedynczej oferty dla publishera
export class Offer {
    offerId?: any;
    offerName?: string;
    countryid: number;
    countryname: string;
    countryalpha2Code: string;
    payout?: number;
    offerTrackingLink?: string;
    offerCategoryId?: number;
    offerCategoryname: string;
    offerDevices: any[];
    offerGlobalStatus?: string;
    offerPublisherStatus?: any;
    operatingSystems?: string[];
  }

export class OfferStatus {
  statusId: number; // Active=1 Disabled=3
}
